import { useInstance } from 'intact-vue';
import { watchState } from '../../hooks/useState';
export function useMerge(getCols, data) {
  var instance = useInstance();
  var grid = [];
  function handleSpans() {
    grid = [];
    var _instance$get = instance.get(),
      merge = _instance$get.merge,
      checkType = _instance$get.checkType;
    if (!data.value || !data.value.length || !merge) return;
    var cols = getCols();
    data.value.forEach(function (data, rowIndex) {
      var currentRow = [];
      grid.push(currentRow);
      var columnIndexOffset = 0;
      if (checkType !== 'none') {
        handleGridItem(currentRow, merge, data, null, rowIndex, 0);
        columnIndexOffset = 1;
      }
      cols.forEach(function (props, columnIndex) {
        handleGridItem(currentRow, merge, data, props, rowIndex, columnIndex + columnIndexOffset);
      });
    });
  }
  function handleGridItem(currentRow, merge, data, column, rowIndex, columnIndex) {
    var prevCell = currentRow[columnIndex - 1];
    var tmp;
    if (prevCell && (tmp = prevCell.spans) && tmp.colspan > 1) {
      currentRow.push({
        render: false,
        spans: {
          rowspan: tmp.rowspan,
          colspan: tmp.colspan - 1
        }
      });
      return;
    }
    if (rowIndex > 0) {
      var prevRow = grid[rowIndex - 1];
      var aboveCell = prevRow[columnIndex];
      if (aboveCell && (tmp = aboveCell.spans) && tmp.rowspan > 1) {
        currentRow.push({
          render: false,
          spans: {
            rowspan: tmp.rowspan - 1,
            colspan: tmp.colspan
          }
        });
        return;
      }
    }
    currentRow.push({
      render: true,
      spans: merge(data, column, rowIndex, columnIndex)
    });
  }
  function getGrid() {
    return grid;
  }
  instance.on('$receive:children', handleSpans);
  watchState(data, handleSpans);
  return {
    getGrid: getGrid
  };
}